import { AlreadyTranslatedText } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import * as React from 'react';
import {
  DragDropContext,
  DraggableProvided,
  Droppable,
  DroppableProvided,
} from '@hello-pangea/dnd';
import Accordion from '../../../../../Accordion';
import LearningCollectionEditStore from '../../../Edit/Store';
import { LearningDesignSection, sectionContext } from '../../../Types';
import CustomizeTableHead from '../CustomizeTableHead';
import DeletedExperiences from '../DeletedExperiences';
import Experiences from '../Experiences';
import DestroySection from './DestroySection';

interface Props {
  titleIcon: React.ReactNode;
  title?: AlreadyTranslatedText;
  store: LearningCollectionEditStore;
  customizationActions?: React.ReactNode;
  openByDefault: boolean;
  titleJSX?: React.ReactNode;
  countDisplay: React.ReactNode;
  section: LearningDesignSection;
  provided: DraggableProvided;
}

const CustomizeExperiences: React.FC<Props> = ({
  title,
  titleIcon,
  store,
  customizationActions,
  openByDefault,
  countDisplay,
  titleJSX,
  section,
  provided,
}) => {
  return (
    <div
      className="border border-gray-200 mb-2"
      data-intercom-target="learning-design-section"
      ref={provided.innerRef}
      {...provided.draggableProps}
    >
      <Accordion
        title={title}
        titleJSX={titleJSX}
        titleIcon={titleIcon}
        openByDefault={openByDefault}
        className="flex items-center justify-between bg-white px-7 py-4"
        rightIcon={<DestroySection store={store} section={section} />}
      >
        <div className="overflow-auto border-t-1 border-gray-200 bg-gray-50 px-5 pb-5">
          <div className="flex items-center justify-between">
            <p className="px-2.5 pt-5 text-sm">{countDisplay}</p>
            <div className="px-2.5 pt-5">{customizationActions || <></>}</div>
          </div>
          <table className="mt-4 w-full">
            <thead className="border-b">
              <tr>
                <CustomizeTableHead context={sectionContext(section)} store={store} />
              </tr>
            </thead>
            <DragDropContext onDragEnd={store.handleOnDragEndExperience(section)}>
              <Droppable droppableId="characters">
                {(provided: DroppableProvided) => {
                  return (
                    <tbody
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      className="bg-white"
                    >
                      <Experiences
                        context={sectionContext(section)}
                        learningCollectionStore={store}
                      />
                      {provided.placeholder}
                    </tbody>
                  );
                }}
              </Droppable>
            </DragDropContext>
            <tbody className="bg-white">
              <DeletedExperiences
                context={sectionContext(section)}
                learningCollectionStore={store}
              />
            </tbody>
          </table>
        </div>
      </Accordion>
    </div>
  );
};

export default observer(CustomizeExperiences);
